import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { TargetIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const trafficLights = [{
    color: 'Verde',
    label: 'Nutrientes',
    bg: 'bg-green-500/20',
    border: 'border-green-500'
  }, {
    color: 'Amarillo',
    label: 'Circunstanciales',
    bg: 'bg-yellow-500/20',
    border: 'border-yellow-500'
  }, {
    color: 'Rojo',
    label: 'Tóxicas',
    bg: 'bg-red-500/20',
    border: 'border-red-500'
  }];
  return <section ref={ref} className="w-full bg-dark-navy py-16 md:py-20 px-6" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <div className="text-center mb-12" data-id="element-105">
            <div className="inline-flex items-center gap-3 mb-6 bg-cyan/10 px-6 py-3 rounded-full border border-cyan/30" data-id="element-106">
              <TargetIcon className="w-6 h-6 text-cyan" data-id="element-107" />
              <span className="text-cyan font-bold uppercase tracking-wider text-sm" data-id="element-108">
                El Mecanismo Único
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-oswald text-gold mb-6" data-id="element-109">
              El Método del Semáforo 360°
            </h2>
          </div>

          <div className="bg-gradient-to-br from-cyan/5 to-gold/5 p-8 md:p-12 rounded-xl border border-cyan/20 mb-10" data-id="element-110">
            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-111">
              En lugar de juzgar o espiar, este sistema le da a tu hijo (y a ti)
              una métrica objetiva para evaluar relaciones. Aprenderás a
              clasificar las influencias en:
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-112">
              {trafficLights.map((light, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} animate={isInView ? {
              opacity: 1,
              scale: 1
            } : {
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className={`${light.bg} p-6 rounded-lg border-2 ${light.border} text-center`} data-id="element-113">
                  <div className={`w-16 h-16 rounded-full ${light.border} border-4 mx-auto mb-4`} data-id="element-114"></div>
                  <h3 className="text-xl font-oswald text-white mb-2" data-id="element-115">
                    {light.color}
                  </h3>
                  <p className="text-gray-300" data-id="element-116">{light.label}</p>
                </motion.div>)}
            </div>

            <p className="text-lg text-gray-300 leading-relaxed text-center" data-id="element-117">
              <span className="text-gold font-bold" data-id="element-118">
                No se trata de controlar a quién ve
              </span>
              , sino de entrenar su criterio para que sea{' '}
              <span className="text-cyan font-bold" data-id="element-119">ÉL quien decida</span>{' '}
              alejarse de lo que le hace daño.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}